import { resolveFirestoreImage } from "./firestoreMedia";

/**
 * Playhouses listing (/playhouses): each card’s image comes from
 * Pages/{docId}.heroImage (same as that playhouse’s detail hero).
 */
export const PLAYHOUSE_LISTING_CARD_META = [
  {
    key: "cottage",
    docId: "cottagePage",
    fallback: "/images/cottage.png",
    label: "Cottage",
    detailNavLabel: "The Cottage",
  },
  {
    key: "ranch",
    docId: "ranchPage",
    fallback: "/images/ranch.png",
    label: "Ranch",
    detailNavLabel: "The Ranch",
  },
  {
    key: "sweetshop",
    docId: "sweetshopPage",
    fallback: "/images/sweetshoppe.png",
    label: "Sweet Shoppe",
    detailNavLabel: "The Sweet Shoppe",
  },
  {
    key: "clubhouse",
    docId: "clubhousePage",
    fallback: "/images/clubhouse.png",
    label: "Clubhouse",
    detailNavLabel: "The Clubhouse",
  },
];

/** Kept for admin + listing; same as resolveFirestoreImage */
export function heroImageDisplaySrc(heroImage, fallback) {
  return resolveFirestoreImage(heroImage, fallback);
}
